
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface OtpState {
  email: string | null;
  otpVerified: boolean;
  loading: boolean;
  error: string | null;
  expiresInMinutes: number;
}

export function createInitialState(): OtpState {
  return {
    email: null,
    otpVerified: false,
    loading: false,
    error: null,
    expiresInMinutes: 0
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'otp', resettable: true })
export class OtpStore extends Store<OtpState> {
  constructor() {
    super(createInitialState());
  }

  setEmail(email: string) {
    this.update({ email });
  }

  setOtpVerified(verified: boolean) {
    this.update({ otpVerified: verified });
  }

  setOtpLoading(loading: boolean) {
    this.update({ loading });
  }

  setOtpError(error: string | null) {
    this.update({ error, loading: false });
  }

  setExpiresIn(minutes: number) {
    this.update({ expiresInMinutes: minutes });
  }

  clearOtpState() {
    this.update(createInitialState());
  }
}
